import { ContainerProps } from "./Grid.types";

export function Container({ fluid, children }: ContainerProps) {
  return (
    <div className={fluid ? "container-fluid" : "container"}>{children}</div>
  );
}
